import { useEffect } from 'react' 
import useRealtimeClient from './useRealtimeClient'

function useRealtimeSubscription(params = {}, deps = []){
  const {
    apiKey, channelName, clientRef: existingClientRef, eventName, callbacks,
  } = params

  const { success: successFn } = callbacks || {}

  const { clientRef: newClientRef } = useRealtimeClient({ apiKey, disabled: !!existingClientRef }, [...deps, apiKey])

  const clientRef = existingClientRef || newClientRef
  const client = clientRef.current

  useEffect(() => {
    const missingKeys = deps ? deps.filter(i => (i === undefined || i === null)) : []

    if (client && !missingKeys.length){
      const channel = client.channels.get(channelName)
      channel.subscribe(eventName, ({ data }) => {
        if (successFn) successFn(data)
      })
    }
  }, [...deps, client])

  return {
    clientRef,
  }
}

export default useRealtimeSubscription
